var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { usePopup } from "@/hooks/layout";
import { useState } from "react";
export function ContactPage() {
    var _this = this;
    var _a = useState({
        name: "",
        email: "",
        reason: "",
        notes: "",
    }), contact = _a[0], setContact = _a[1];
    var _b = useState(""), message = _b[0], setMessage = _b[1];
    var fieldStyle = "flex flex-col mb-2";
    var confirmation = function () { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, showPopup({
                        type: "dev/popup/confirm",
                        payload: {
                            title: "Soumettre les données suivantes ?",
                            content: JSON.stringify(contact),
                            buttons: {
                                confirm: "Oui",
                                cancel: "Non",
                            },
                        },
                    })];
                case 1:
                    result = _a.sent();
                    if ((result === null || result === void 0 ? void 0 : result.reason) === "confirm") {
                        setMessage("Informations soumises: " + JSON.stringify(contact));
                        closePopup("null", "null");
                    }
                    else {
                        setMessage("");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    function handleSubmit(e) {
        e.preventDefault();
        confirmation();
    }
    var _c = usePopup(), showPopup = _c.showPopup, closePopup = _c.closePopup;
    return (_jsxs("div", __assign({ className: "flex flex-col max-w-md py-10 mx-auto" }, { children: [_jsx("b", __assign({ className: "text-center text-fuchsia-500" }, { children: message })), _jsx("h2", __assign({ className: "mb-3 text-3xl font-bold underline" }, { children: "Contact Us" })), _jsx("p", __assign({ className: "mb-3" }, { children: "If you enter your details we'll get back to you as soon as we can." })), _jsxs("form", __assign({ onSubmit: handleSubmit }, { children: [_jsxs("div", __assign({ className: fieldStyle }, { children: [_jsx("label", __assign({ htmlFor: "name" }, { children: "Your name" })), _jsx("input", { type: "text", id: "name", value: contact.name, onChange: function (e) { return setContact(__assign(__assign({}, contact), { name: e.target.value })); } })] })), _jsxs("div", __assign({ className: fieldStyle }, { children: [_jsx("label", __assign({ htmlFor: "email" }, { children: "Your email address" })), _jsx("input", { type: "email", id: "email", value: contact.email, onChange: function (e) { return setContact(__assign(__assign({}, contact), { email: e.target.value })); } })] })), _jsxs("div", __assign({ className: fieldStyle }, { children: [_jsx("label", __assign({ htmlFor: "reason" }, { children: "Reason you need to contact us" })), _jsxs("select", __assign({ id: "reason", value: contact.reason, onChange: function (e) { return setContact(__assign(__assign({}, contact), { reason: e.target.value })); } }, { children: [_jsx("option", { value: "" }), _jsx("option", __assign({ value: "Support" }, { children: "Support" })), _jsx("option", __assign({ value: "Feedback" }, { children: "Feedback" })), _jsx("option", __assign({ value: "Other" }, { children: "Other" }))] }))] })), _jsxs("div", __assign({ className: fieldStyle }, { children: [_jsx("label", __assign({ htmlFor: "notes" }, { children: "Additional notes" })), _jsx("textarea", { id: "notes", value: contact.notes, onChange: function (e) { return setContact(__assign(__assign({}, contact), { notes: e.target.value })); } })] })), _jsx("div", { children: _jsx("button", __assign({ type: "submit", className: "h-10 px-6 mt-2 font-semibold text-white bg-black" }, { children: "Submit" })) })] }))] })));
}
widgetsDictionary.register("dev/form/test", {
    name: "Exemple de formulaire",
    display: ContactPage,
    selectable: false,
});
